import { useState, useEffect } from "react";
import { db, auth } from "./firebase.js"; // Make sure 'auth' is imported
import { collection, addDoc, Timestamp } from "firebase/firestore";

export default function Feedback() {
  const [show, setShow] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((u) => {
      setUser(u);
    });
    return () => unsub();
  }, []);

  const handleSubmit = async () => {
    if (!feedback.trim()) return;

    setLoading(true);
    try {
      await addDoc(collection(db, "feedback"), {
        message: feedback.trim(),
        email: user?.email ?? "anonymous",
        createdAt: Timestamp.now(),
      });
      setFeedback("");
      setSubmitted(true);
    } catch (error) {
      console.error("Error submitting feedback:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button
        onClick={() => setShow(!show)}
        className="relative text-blue-600 hover:underline"
      >
        Contact Us
      </button>

      {show && (
        <div className="absolute left-1/2 transform -translate-x-1/2 mt-4 w-[90vw] max-w-2xl bg-white shadow-lg border rounded p-6 z-50 text-left overflow-y-auto max-h-[80vh] space-y-6">
          <button
            onClick={() => setShow(false)}
            className="absolute top-2 right-2 text-gray-500 hover:text-black text-lg"
          >
            ×
          </button>
          <div className="max-w-xl mx-auto border-t pt-6 mt-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Have a suggestion or question?
            </h3>
            <textarea
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              rows="4"
              placeholder="Your feedback here..."
              className="w-full border rounded p-3 text-sm text-gray-700"
            />
            <button
              onClick={handleSubmit}
              disabled={loading || submitted}
              className={`mt-3 w-full py-2 text-sm font-medium rounded ${
                submitted
                  ? "bg-green-500 text-white cursor-default"
                  : "bg-blue-600 text-white hover:bg-blue-700"
              }`}
            >
              {submitted
                ? "Thank you!"
                : loading
                ? "Sending..."
                : "Send Feedback"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
